import type { L10n } from "@/lib/locales"

export type JobOpening = {
  id: string
  title: L10n
  location: L10n
  employment: L10n
  description: L10n
}

// Add only real, currently open positions. New IDs trigger the site notice.
export const jobOpenings: JobOpening[] = []
